module.exports = __webpack_public_path__ + "img/twitterX-logo.08c765d8.svg";